import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="art-deco-footer">
      <div className="zigzag"></div>
      
      <div className="footer-content">
        <div className="footer-brand">
          <h1>ME DECADE</h1>
          <div className="footer-subtitle">INTERIOR</div>
          <div className="footer-ornament">◆ ◆ ◆</div>
          <p>Surface Pattern Design Studio</p>
        </div>
        
        <div className="footer-links">
          <div className="link-group">
            <h4>STUDIO</h4>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#patterns">Patterns</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="link-group">
            <h4>SERVICES</h4>
            <ul>
              <li><a href="#interior">Interior Design</a></li>
              <li><a href="#product">Product Design</a></li>
              <li><a href="#branding">Branding</a></li>
              <li><a href="#custom">Custom Patterns</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-ornaments">
          <span className="ornament">◆</span>
          <span className="ornament">●</span>
          <span className="ornament">▲</span>
          <span className="ornament">■</span>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="copyright">
          <p>&copy; {currentYear} ME DECADE. ALL RIGHTS RESERVED.</p>
        </div>
        <div className="bottom-ornament">
          <span>◆</span>
          <span>●</span>
          <span>◆</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;